import { forwardRef, type Ref, type SVGProps } from "react";
const IconNightLifeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.283 6H19.68l2.501-3.573a1 1 0 1 1 1.638 1.147L22.12 6h3.595c.872 0 1.326 1.038.735 1.678L16.996 17.92q.003.04.003.08v8h4a1 1 0 0 1 0 2H11a1 1 0 1 1 0-2h4v-8q0-.04.003-.08L5.548 7.678C4.958 7.038 5.411 6 6.283 6m9.143 7.82a1 1 0 0 1-.246-1.393L18.279 8H8.567L16 16.051l7.432-8.05H20.72l-3.902 5.572a1 1 0 0 1-1.392.246z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconNightLifeOutlineSVG);
ForwardRef.displayName = "IconNightLifeOutline";
export { ForwardRef as IconNightLifeOutline };
